import { Inject, Injectable, Injector } from '@angular/core';
import { PlanoPagamentoResponse } from '../models/plano-pagamento.model';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class PlanoPagamentoApiService extends UtilsBaseApiService<PlanoPagamentoApiService> {
  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector
  ) {
    super('planopagamento', injector, environment.BASE_API_URL);
  }

  readonly TIPO_ENVIO_EXTENSION = 'TP_ENVIO';
  readonly METODO_PÁGAMENTO = 'metodoPag';
  readonly COBRANCA = 'planoByCob';

  getPlanosPagamento() {
    return this.httpClient.get<PlanoPagamentoResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/?${this.TIPO_ENVIO_EXTENSION}=1`
    );
  }

  getPlanoPagamentoByCobranca(cobranca: number) {
    return this.httpClient.get<PlanoPagamentoResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.COBRANCA}/${cobranca}`
    );
  }

  getMetodoPagamento() {
    return this.httpClient.get<PlanoPagamentoResponse[]>(
      `${this.BASE_URL}${this.CONTEXT}/${this.METODO_PÁGAMENTO}`
    );
  }
}
